import * as React from 'react';

export const LikeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 14L12 4.87405L7.67834 0.446253C7.44524 0.163766 7.09637 0 6.72697 0H6.44624C5.76824 0 5.21841 0.54207 5.21841 1.2105V4.45146H1.43848C0.643928 4.45146 0 5.08668 0 5.86962C0 7.69118 1.30873 11.0518 2.05884 12.8283C2.36239 13.5473 3.07117 14 3.85156 14H12ZM13 5H16V14H13V5Z" fill="#0468FF"/>
  </svg>
);
